import React, { useEffect } from 'react'
import './EasyStepCard.css'
import { motion, useAnimation } from "framer-motion";
export default function EasyStepCard(props) {

  const controls = useAnimation();

  useEffect(() => {
    if (props.active) {
      controls.start({ 
        // Changed Scale from 1.1 to 1.05
        scale: 1.05 
      });
    } else {
      controls.start({ scale: 1 });
    }
  }, [props.active, controls]);

  return (
    <motion.div animate={controls}
      initial={{
        scale: 1
      }}
      transition={{ 
        ease: "easeOut", 
        duration: 0.1
      }}
      onMouseOver={
        props.onMouseOver
      }
      onMouseLeave={
        props.onMouseLeave
      }
      className={`easy-step-card ${props.active ? 'active' : ''} res-gap-24 `}>

      <span className='esc-step fw-semibold fs-700'>{props.step}</span>

      <div className='container-vertical res-gap-8'>

        <span className='esc-heading fw-semibold fs-regular'>
          {props.heading}
        </span>
        <p className='esc-content fw-regular fs-small'>
          {props.content}
        </p>
      </div>
    </motion.div>
  )
}
